/**
 * @module AEM
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { Component, OnInit, Input } from '@angular/core';
import { ByodFaqAuthorable, FaqItem } from '../byod-faq-authorable/models/byod-faq-authorable';
import { ContainerData } from '../container/models/container-data.interface';
import { ContentItem } from '@core/aem/models/content-item.interface';
import { AuthorableComponent } from '@core/aem/models/authorable-component.model';

@Component({
  selector: 'tmo-byod-page-faq',
  templateUrl: './byod-page-faq.component.html',
  styleUrls: ['./byod-page-faq.component.scss'],
})
export class ByodPageFaqComponent extends AuthorableComponent<ByodFaqAuthorable> implements OnInit {
  /**
   * Stores the value of faqLimit.
   */
  public faqLimit: number;

  @Input() public isDynamicContent: ContentItem<ContainerData>[];

  /**
   * Stores FAQ List.
   */
  public showFaqList: FaqItem[];

  constructor() {
    super();
    // TODO: value should come from AEM
    const faqDefaultLimit = 4;
    this.faqLimit = faqDefaultLimit;
  }

  public ngOnInit(): void {}

  public setData(data: ByodFaqAuthorable): void {
    if (this.validate(data)) {
      this.filterFaq(data.items);
      this.updateFaqLimit(data.limit);
    }
  }

  public validate(data: ByodFaqAuthorable): boolean {
    if (!(data.items && data.items.length > 0)) {
      throw new Error(`Invalid options for text ${data}: Required fields [text]`);
    }
    return true;
  }

  public filterFaq(items: FaqItem[]): void {
    this.showFaqList = items.filter((item: FaqItem, index: number) => index < this.faqLimit);
  }

  private updateFaqLimit(faqLimit?: string): void {
    const radix = 10;
    this.faqLimit = faqLimit ? parseInt(faqLimit, radix) : this.faqLimit;
  }
}
